import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const clientOnSiteRouter: Array<RouteConfig> = [
  {
    path: "clients_on_site_list",
    name: "clients_on_site_accounts",
    component: () => import("@/views/ClientsOnSite/ClienOnSitetList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "subscription_email",
    name: "subscription_email",
    component: () => import("@/views/ClientsOnSite/EmailList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "subscription_phone",
    name: "subscription_phone",
    component: () => import("@/views/ClientsOnSite/PhoneList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "new_client",
    name: "new_client",
    component: () => import("@/views/ClientsOnSite/NewAccount.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "",
    name: "clients_on_site",
    redirect: { name: "client_on_site_accounts" }
  }
];

export default clientOnSiteRouter;
